<template>
  <v-row class="mt-5 mb-5 text-center" v-if="pagesTotal > 1 && loading === false">
    <v-pagination class="mt-5 mb-5" :value="value" @input="updatePage" total-visible="7" :length="pagesTotal"></v-pagination>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Pagination',
  props: ['value'],
  data() {
    return { page: 1 }
  },
  computed: mapGetters(['pagesTotal', 'loading']),
  methods: {
    updatePage (page) {
      this.$emit('input', page)
    }
  }
}
</script>
